<template>
  <div>
    <div
      v-if="anyUserOrganizationsAvailable"
      :class="appUserRole !== 'worker' ? 'approved-app-user-listing' : ''"
    >
      <v-row v-if="!workerCheck && companyVisibility">
        <v-col
          cols="10"
          class="pb-0 pt-0"
        >
          <v-select
            v-model="selectedCompany"
            light
            color="#37474F"
            flat
            dense
            :items="appUserCompanies"
            item-text="name"
            item-value="id"
            label="Company"
            outlined
            background-color="transparent"
            class="small-select"
            @change="changeCompany"
          />
        </v-col>
        <v-col
          cols="2"
          class="d-flex pb-0 pt-0"
        >
          <v-btn
            fab
            small
            outlined
            color="#37474F"
            elevation="0"
            @click="clearAllFilters"
          >
            <v-icon size="18">
              mdi-filter-off
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-if="!workerCheck"
        class="py-0"
      >
        <v-col class="pt-0 pr-0">
          <v-text-field
            v-model="searchQuery"
            placeholder="Search..."
            outlined
            hide-details
            color="#37474F"
            light
            class="search-bar"
            dense
            flat
          />
        </v-col>
        <v-col
          cols="2"
          class="d-flex pt-0"
        >
          <v-btn
            fab
            small
            outlined
            color="#37474F"
            elevation="0"
            @click="searchAppUser()"
          >
            <v-icon size="20">
              mdi-magnify
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <br>
      <div v-if="!workerCheck">
        <div v-if="anyAppUsersListAvailable">
          <v-card
            v-for="(item, index) in appUsersList"
            :key="index"
            class="mb-4 user-card"
            elevation="0"
            :class="getStatusBorderClass(item.request_status)"
          >
            <div class="d-flex align-center bg-light pa-4">
              <v-avatar
                color="blue-grey lighten-4"
                size="48"
                class="mr-4"
              >
                <span class="blue-grey--text text--darken-3 font-weight-bold">
                  {{ item.first_name[0] }}{{ item.last_name[0] }}
                </span>
              </v-avatar>

              <div class="flex-grow-1">
                <v-row no-gutters>
                  <v-col cols="9">
                    <p class="title-text-style mb-1">
                      Name:
                      <span class="value-text-style">
                        {{ item.first_name }} {{ item.last_name }}
                      </span>
                    </p>
                    <p class="title-text-style mb-0">
                      Company:
                      <span class="value-text-style">
                        {{ item.company.name }}
                      </span>
                    </p>
                  </v-col>

                  <v-col
                    cols="3"
                    class="d-flex justify-end align-start"
                  >
                    <v-chip
                      dark
                      rounded
                      outlined
                      color="#e6e6e6"
                      x-small
                      class="status-style"
                    >
                      <span>{{ item.request_status | currentStatus }}</span>
                    </v-chip>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card>
          <div class="text-center">
            <v-progress-circular
              v-if="lazyLoader"
              size="25"
              :width="1"
              color="#CCC"
              indeterminate
            />
          </div>
          <div
            ref="observer"
            class="observer"
          />
        </div>
        <div
          v-else
          class="empty-alert-div mt-3"
        >
          <v-card
            color="#FFF"
            elevation="0"
          >
            <br><br>
            <p class="empty-alert-msg">
              <v-icon
                size="25"
                color="#C62828"
              >
                mdi-information-outline
              </v-icon>
              No App users found
            </p>
            <br><br>
          </v-card>
        </div>
      </div>
      <div v-else>
        <div class="empty-alert-div">
          <v-card
            color="#FFF"
            elevation="0"
          >
            <br><br><br>
            <p class="empty-alert-msg">
              <v-icon
                size="25"
                color="#C62828"
              >
                mdi-information-outline
              </v-icon>
              You don't have permission to view this resource
            </p>
            <br><br>
          </v-card>
        </div>
      </div>
    </div>
    <div
      v-else
      class="empty-alert-div mt-4"
    >
      <v-card
        color="#FFF"
        elevation="0"
      >
        <br><br><br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>
          No Organizations found
        </p>
        <br><br>
      </v-card>
    </div>
    <centre-spinner :loading="loading" />
    <app-user-edit-form
      v-if="showEditForm"
      :org-external-id="orgExternalId"
      :appuser-id="appuserId"
      :app-user-role="appUserRole"
      :selected-req-status="selectedReqStatus"
      @closed="closeForm"
    />
    <alert-dialog
      v-if="showDeleteAlert"
      title="Confirm Delete"
      message="Are you sure you want to delete the AppUser?"
      @closed="showDeleteAlert = false"
      @confirmed="deleteAppUser()"
    />
    <alert-dialog
      v-if="showDeclineAlert"
      title="Confirm Decline"
      message="Are you sure you want to decline the AppUser?"
      @closed="showDeclineAlert = false"
      @confirmed="declineAppUser()"
    />
  </div>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import AppUserEditForm from './AppUserEditForm.vue';
import Constants from 'src/constants';
import AlertDialog from '../../../../components/AlertDialog.vue';

export default {
  name: 'PendingAppUsersList',
  components: {
    'centre-spinner': spinner,
    'app-user-edit-form': AppUserEditForm,
    'alert-dialog': AlertDialog,
  },
  filters: {
    currentStatus (val) {
      if (val === 'pending') return 'Pending';
      if (val === 'declined') return 'Declined';
      return 'Waiting';
    },
  },
  data: () => ({
    loading: false,
    observer: null,
    observerFetching: false,
    startPage: 0,
    lazyLoader: false,
    showEditForm: false,
    showDeleteAlert: false,
    showDeclineAlert: false,
    showSearch: false,
    searchQuery: null,
    selectedCompany: null,
    appuserId: null,
    appUserRole: null,
    selectedOrgExtId: null,
    selectedAppUserExtId: null,
    selectedAppUserOrgId: null,
    selectedReqStatus: null,
    currentOrg: null,
    workerCheck: false,
    companyVisibility: false,
  }),
  computed: {
    appUsersList () {
      return this.$store.getters['appusers/getPendingAppUsersList'];
    },
    anyAppUsersListAvailable () {
      return this.appUsersList.length > 0;
    },
    appUserRoleCheck () {
      return (
        this.appUserRole === 'site-manager' || this.appUserRole === 'contractor'
      );
    },
    appUserOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    appUserCompanies () {
      return this.$store.getters['company/getAppUsersCompanies'];
    },
    anyUserOrganizationsAvailable () {
      return this.appUserOrganizations.length > 0;
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
  },
  async mounted () {
    this.loading = true;
    await this.$store.dispatch('appusers/clearPendingAppUsersList');
    await this.loadOnMount();
    this.loading = false;
  },
  methods: {
    async loadOnMount () {
      this.loading = true;
      await this.getUserOrganizations();
      this.loading = false;
    },
    async getAppUserCompanies () {
      this.loading = true;
      await this.$store.dispatch('company/fetchAppUsersCompanies', {
        organizationId: this.selectedOrganization.organization.external_id,
      });
      this.loading = false;
    },
    async getUserOrganizations () {
      this.loading = true;
      await this.$store.dispatch('organization/fetchUserOrganizations', {
        params: { requestStatus: 'accepted' },
      });
      if (this.anyUserOrganizationsAvailable) {
        this.currentOrg = this.appUserOrganizations.filter(
          (item) =>
            item.organization.external_id ===
            this.selectedOrganization.organization.external_id,
        );
        this.appUserRole = this.currentOrg[0].app_user_role;

        if (this.appUserRole === 'site-manager') {
          this.workerCheck = false;
          this.companyVisibility = true;
          await this.getAppUserCompanies();
        } else if (this.appUserRole === 'contractor') {
          this.workerCheck = false;
          this.companyVisibility = false;
          this.selectedCompany = this.currentOrg[0].company.id;
        } else if (this.appUserRole === 'worker') {
          this.workerCheck = true;
        }
        await this.getAppUsersList();
        await this.initObserver();
      }
      this.loading = false;
    },
    async changeCompany (companyId) {
      this.loading = true;
      this.startPage = 0;
      this.selectedCompany = companyId;
      this.searchQuery = '';
      await this.$store.dispatch('appusers/clearPendingAppUsersList');
      await this.getAppUsersList();
      await this.initObserver();
      this.loading = false;
    },
    async searchAppUser () {
      this.startPage = 0;
      this.loading = true;
      await this.$store.dispatch('appusers/clearPendingAppUsersList');
      await this.getAppUsersList();
      await this.initObserver();
      this.loading = false;
    },
    async clearAllFilters () {
      this.startPage = 0;
      this.searchQuery = '';
      this.selectedCompany = null;
      this.loading = true;
      await this.$store.dispatch('appusers/clearPendingAppUsersList');
      await this.getAppUsersList();
      await this.initObserver();
      this.loading = false;
    },
    async getAppUsersList () {
      if (this.lazyLoader) return;
      this.lazyLoader = true;
      await this.$store.dispatch('appusers/fetchPendingAppUsersList', {
        orgExternalId: this.selectedOrganization.organization.external_id,
        params: {
          params: {
            requestStatus: ['pending', 'declined', 'waiting'],
            startPage: this.startPage,
            limit: 5,
            companyId: this.selectedCompany,
            name: this.searchQuery || null,
          },
        },
      });
      const fetchedLength =
        this.$store.getters['appusers/getPendingAppUsersList'].length;
      if (fetchedLength <= this.startPage) {
        if (this.observer) this.observer.disconnect();
      } else {
        this.startPage += 5;
      }
      this.lazyLoader = false;
    },
    initObserver () {
      if (this.observer) this.observer.disconnect();

      const options = { root: null, rootMargin: '0px', threshold: 0.5 };
      this.observer = new IntersectionObserver(this.handleIntersect, options);
      if (this.$refs.observer) this.observer.observe(this.$refs.observer);
    },
    handleIntersect (entries) {
      if (entries[0].isIntersecting && !this.observerFetching) {
        this.observerFetching = true;
        this.getAppUsersList().finally(() => {
          this.observerFetching = false;
        });
      }
    },
    openAcceptForm (item) {
      this.appuserId = item.external_id;
      this.orgExternalId = item.organization.external_id;
      this.showEditForm = true;
    },
    openEditForm (item) {
      this.appuserId = item.external_id;
      this.orgExternalId = item.organization.external_id;
      this.selectedReqStatus = item.request_status;
      this.showEditForm = true;
    },
    getStatusBorderClass (status) {
      if (status === 'pending') return 'pending-border';
      if (status === 'declined') return 'declined-border';
      return 'waiting-border';
    },
    async closeForm () {
      this.showEditForm = false;
      this.loading = true;
      await this.$store.dispatch('appusers/clearPendingAppUsersList');
      this.startPage = 0;
      this.searchQuery = '';
      await this.getAppUsersList();
      await this.initObserver();
      this.loading = false;
    },
    confirmDelete (item) {
      this.selectedOrgExtId = item.organization.external_id;
      this.selectedAppUserExtId = item.external_id;
      this.showDeleteAlert = true;
    },
    async deleteAppUser () {
      this.showDeleteAlert = false;
      this.loading = true;
      try {
        await this.$store.dispatch('appusers/deleteAppUser', {
          orgExternalId: this.selectedOrgExtId,
          appUserExtId: this.selectedAppUserExtId,
        });
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Deleted Successfully!',
            type: Constants.ALERT_TYPE_SUCCESS,
          },
          { root: true },
        );
      } catch (err) {
        this.loading = false;
      }
      await this.$store.dispatch('appusers/clearPendingAppUsersList');
      this.startPage = 0;
      this.searchQuery = '';
      await this.getAppUsersList();
      await this.initObserver();
      this.loading = false;
    },
    confirmDecline (item) {
      this.selectedAppUserOrgId = item.app_user_organization_id;
      this.showDeclineAlert = true;
    },
    async declineAppUser () {
      this.showDeclineAlert = false;
      this.loading = true;
      await this.$store.dispatch('appusers/updateAppUserStatus', {
        appUserOrganizationId: this.selectedAppUserOrgId,
        status: { request_status: 'declined' },
      });
      await this.$store.dispatch('appusers/clearPendingAppUsersList');
      this.startPage = 0;
      this.searchQuery = '';
      await this.getAppUsersList();
      await this.initObserver();
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.container {
  border-radius: 10px !important;
  padding: 0px !important;
}
p {
  margin-bottom: 5px;
}
.details-container {
  width: 100% !important;
  border-radius: 10px;
  background: #fff;
}
.btn-position {
  position: absolute;
  right: 0;
}
.theme--dark.v-list {
  background-color: white !important;
}
.theme--dark >>> .v-list-item {
  color: #37474f !important;
}
.observer {
  height: 40px;
}
.col-5 {
  padding: 12px;
  padding-right: 0;
}
.col-10 {
  padding: 12px;
  padding-right: 0px;
}
.status-style {
  display: flex;
  justify-content: flex-end;
  width: fit-content;
  float: right;
}
.approved-app-user-listing {
  margin-top: 40px;
}
.user-card {
  border-left: 5px solid transparent;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  background-color: white !important;
  border-radius: 8px !important;
  overflow: hidden;
}

.user-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.bg-light {
  background-color: #fcfcfc;
}

/* Side Border Colors */
.pending-border {
  border-left-color: #ffca68 !important;
}
.declined-border {
  border-left-color: #e53935 !important;
}
.waiting-border {
  border-left-color: #607d8b !important;
}

.title-text-style {
  font-weight: bold;
  color: #757575;
  font-size: 0.9rem;
}

.value-text-style {
  font-weight: normal;
  color: #37474f;
}
</style>
